import React from "react";
import { motion } from "framer-motion";

export const SectionTitle = ({ kicker, title, testid }) => (
  <div className="mb-12">
    {kicker && (
      <motion.p
        initial={{ opacity: 0, x: -20 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-3 font-heading text-xs uppercase tracking-[0.4em] text-electric"
      >
        {kicker}
      </motion.p>
    )}
    <motion.h2
      data-testid={testid}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.7 }}
      className="font-display text-4xl font-black text-white sm:text-5xl lg:text-6xl"
    >
      {title}
    </motion.h2>
  </div>
);

export default SectionTitle;
